import { useCallback, useEffect, useMemo, useState } from "react";
import { buscarEdicaoPaciente } from "../services/rastreamento.service";

const mapearDadosEdicao = (paciente = {}, responseData = {}) => {
	const dadosRastreamento = responseData.rastreamentoPacienteOrganizado || {};

	return {
		...paciente,
		...responseData,
		tipoControle: dadosRastreamento.tipoRastreamento?.descricao || "—",
		statusAlertaRastreamento:
			dadosRastreamento.statusAlertaRastreamento?.descricaoAlerta || "—",
		statusAlertaRastreamentoMama:
			dadosRastreamento.statusAlertaRastreamentoMama?.descricaoAlerta || "—",
		diretriz: dadosRastreamento.diretriz?.descricao || "—",
		diretrizMama: dadosRastreamento.diretrizMama?.descricao || "—",
		dataValidadeDiretriz: dadosRastreamento.dataValidadeDiretriz || "—",
		dataValidadeDiretrizMama: dadosRastreamento.dataValidadeDiretrizMama || "—",
		statusColo: dadosRastreamento.tipoDeAlerta?.descricao || "—",
		statusGeralMama: dadosRastreamento.tipoDeAlertaMama?.descricao || "—",
		dataUltimoProcessamento: dadosRastreamento.dataUltimoProcessamento || "—",
	};
};

const usePacienteRastreamento = (pacienteSelecionado) => {
	const paciente = useMemo(() => pacienteSelecionado || {}, [pacienteSelecionado]);
	const [dadosCompletos, setDadosCompletos] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	const fetchDadosAtualizados = useCallback(async () => {
		if (!paciente?.id) return;

		setLoading(true);
		setError(null);

		try {
			const response = await buscarEdicaoPaciente(paciente.id);
			setDadosCompletos(mapearDadosEdicao(paciente, response.data));
		} catch (err) {
			console.error("Erro ao atualizar dados do paciente:", err);
			setError(err);
		} finally {
			setLoading(false);
		}
	}, [paciente]);

	useEffect(() => {
		if (!paciente?.id) {
			setDadosCompletos(null);
			return;
		}

		const pacienteJaCompleto = Boolean(paciente?.phones || paciente?.telefone);

		if (pacienteJaCompleto) {
			setDadosCompletos(paciente);
			return;
		}

		fetchDadosAtualizados();
	}, [paciente, fetchDadosAtualizados]);

	return {
		paciente,
		dadosCompletos,
		loading,
		error,
		fetchDadosAtualizados,
		setDadosCompletos,
	};
};

export default usePacienteRastreamento;
